export const QA_NAME_TEST_VARIABLES_ACTION = 'testVariables'

export const QA_NAME_PREVIEW_ACTION = 'preview'
